import styled, { css } from 'styled-components';
import { labelFontColor, erro } from '../../../config/Colors/Ligth';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
  tamanho?: number;
}

export const Container = styled.div<ContainerProps>`
  margin-top: 16px;

  label {
    padding-left: 6px;
    font-size: 10px;
    color: ${labelFontColor};
    ${props =>
    props.isFocused &&
    css`
        font-weight: 700;
      `}
    ${props =>
    props.isErrored &&
    css`
        color: ${erro};
      `}

  div {
      background: transparent;
      border-radius: 4px;
      padding: 8px;
      width: 100%;
      display: flex;
      align-items: center;

      border: 1px solid #c4c4c4;
      color: #666360;

      ${props =>
    props.isErrored &&
    css`
          border-color: ${erro};
        `}

      ${props =>
    props.isFocused &&
    css`
          border-color: ${labelFontColor};
          border-width: 2px;
          color: #666360;
        `}



  input {
        flex: 1;
        background: transparent;
        border: 0;
        border-color: green;

        &::placeholder {
          color: #666360;
        }
      }

      svg {
        margin-right: 16px;
        font-size: 14px !important;
      }
    }

    span {
      padding-top: 0;
      padding-left: 6px;
      font-size: 10px;
    }
  }
`;
